import i18n from '@/modules/i18n';

export default function getErrorMessage(code) {
  const errorCodes = {
    BLOCKS_QUOTA_REACHED: 'This site has reached the maximum number of blocks allowed.',
    BLOCKS_MUST_NOT_HAVE_IDS: 'Blocks cannot contain ID attributes.',
    CONNECTION_AGENT_AUTHENTICATIONERROR: 'Unable to authenticate with your server.',
    CONNECTION_AGENT_CONNECTIONERROR: 'Unable to connect to your website.',
    CONNECTION_AGENT_CREATEDIRERROR: 'Unable to create the directory on your server.',
    CONNECTION_AGENT_DOWNLOADERROR: 'Unable to download the file from your server.',
    CONNECTION_AGENT_LISTERROR: 'Unable to list the directory on your server.',
    CONNECTION_AGENT_MOVEERROR: 'Unable to move the file on your server.',
    CONNECTION_AGENT_REMOVEERROR: 'Unable to delete the file from your server.',
    CONNECTION_AGENT_UPLOADERROR: 'Unable to upload the file to your server.',
    DOMAIN_IN_USE: 'This domain is already in use.',
    EMAIL_IN_USE: 'This email address is already in use.',
    EMAIL_NOT_REGISTERED: 'This email address is not registered.',
    FILE_ALREADY_EXISTS: 'A file already exists at the specified location.',
    FILE_TYPE_NOT_SUPPORTED: 'This type of file is not supported.',
    GA_INSUFFICIENT_PERMISSIONS: 'Your analytics provider says you do not have permission to access this property.',
    GA_INVALID_CREDENTIALS: 'We were unable to fetch data from your analytics provider.',
    GA_NOT_ENABLED: 'The analytics dashboard has not been enabled for this site.',
    INCORRECT_PASSWORD: 'Your password is incorrect.',
    INVALID_UPLOAD_PATH: 'Files cannot be uploaded here.',
    INVALID_RECOVERY_TOKEN: 'The link you followed has expired.',
    NO_PAYMENT_INFO: "You haven't entered your payment info yet.",
    PASSWORD_TOO_SHORT: 'Passwords must be at least eight characters long.',
    PATH_OUTSIDE_OF_HOME_FOLDER: "The selected path is outside of the site's home folder.",
    PUBLISHING_ERROR: 'An error occurred. Please try your request again later.',
    SITE_IS_LOCKED: 'This request cannot be completed because the site is on lockdown.',
    TEMPLATE_QUOTA_REACHED: 'This site has reached the maximum number of templates allowed.',
    UPGRADE_REQUIRED: 'Please upgrade your account to unlock this feature.',
    VALIDATION_ERROR: 'Please correct the highlighted errors.'
  };

  if (errorCodes[code]) {
    return i18n.t(errorCodes[code]);
  } else {
    return i18n.t('An error occurred. Please try your request again later.');
  }
}
